import { render } from "./Tabs.vue?vue&type=template&id=20a545ce&bindings={}"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script